import axios from "axios";
import Config from "../../../config/index";
// import { CREATE_REPAIR_VALUE_FAILURE, CREATE_REPAIR_VALUE_REQUEST, CREATE_REPAIR_VALUE_SUCCESS, GET_DELETE_REPAIR_VALUE_FAILURE, GET_DELETE_REPAIR_VALUE_REQUEST, GET_DELETE_REPAIR_VALUE_SUCCESS, GET_REPAIR_VALUE_FAILURE, GET_REPAIR_VALUE_REQUEST, GET_REPAIR_VALUE_SUCCESS } from "./repairValueTypes";
import {
  CREATE_RETURNS_FAILURE,
  CREATE_RETURNS_REQUEST,
  CREATE_RETURNS_SUCCESS,
  EDIT_RETURNS_FAILURE,
  EDIT_RETURNS_REQUEST,
  EDIT_RETURNS_SUCCESS,
  GET_DELETE_RETURNS_FAILURE,
  GET_DELETE_RETURNS_REQUEST,
  GET_DELETE_RETURNS_SUCCESS,
  GET_REPAIR_FAILURE,
  GET_REPAIR_REQUEST,
  GET_REPAIR_SUCCESS,
  GET_RETURNS_FAILURE,
  GET_RETURNS_REQUEST,
  GET_RETURNS_SUCCESS,
  UPLOAD_RETURNS_FAILURE,
  UPLOAD_RETURNS_REQUEST,
  UPLOAD_RETURNS_SUCCESS,
} from "./returnsTypes";

let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;

const getReturnsRequest = () => {
  return {
    type: GET_RETURNS_REQUEST,
  };
};

const getReturnsSuccess = (payload) => {
  return {
    type: GET_RETURNS_SUCCESS,
    payload: payload,
  };
};

const getReturnsFailure = (error) => {
  return {
    type: GET_RETURNS_FAILURE,
    payload: error,
  };
};
const getReturns = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getReturnsRequest());

    let url;

    // If dppId is provided → call endpoint with dppId
    if (dppId) {
      url = `${baseUrl}/dpp/return_repair_info/get_dpp?dppId=${dppId}`;
    } else {
      // If dppId is NOT provided → call base endpoint
      url = `${baseUrl}/dpp/return_repair_info/get_all`;
    }

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getReturnsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getReturnsFailure(err.message));
      });
  };
};

const getRepairCenterRequest = () => {
  return {
    type: GET_REPAIR_REQUEST,
  };
};

const getRepairCenterSuccess = (payload) => {
  return {
    type: GET_REPAIR_SUCCESS,
    payload: payload,
  };
};

const getRepairCenterFailure = (error) => {
  return {
    type: GET_REPAIR_FAILURE,
    payload: error,
  };
};
const getRepairCenter = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getRepairCenterRequest());

    let url = `${baseUrl}/dpp/get_service_center`;

    axios
      .get(url, headers)
      .then((response) => {
        console.log("response", response);
        dispatch(getRepairCenterSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getRepairCenterFailure(err.message));
      });
  };
};

const deleteReturnRequest = () => {
  return {
    type: GET_DELETE_RETURNS_REQUEST,
  };
};

const deleteReturnSuccess = (payload) => {
  return {
    type: GET_DELETE_RETURNS_SUCCESS,
    payload: payload,
  };
};

const deleteReturnFaliure = (error) => {
  return {
    type: GET_DELETE_RETURNS_FAILURE,
    payload: error,
  };
};

const deleteReturn = (returnId, udBy, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(deleteReturnRequest());
    let url = `${baseUrl}/dpp/return_repair_info/delete?returnId=${returnId}&udBy=${udBy}`;
    // let url = `${baseUrl}/dpp/product_passport/delete?dppId=${dppId}`;
    // let url = `${baseUrl}/mvtmap?id=${productId}`;
    // let url = `/mvtmap?id=334`;
    return axios
      .delete(url, {}, headers)
      .then((response) => {
        dispatch(deleteReturnSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteReturnFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const createReturnsRequest = () => {
  return {
    type: CREATE_RETURNS_REQUEST,
  };
};

const createReturnsSuccess = (payload) => {
  return {
    type: CREATE_RETURNS_SUCCESS,
    payload: payload,
  };
};

const createReturnsFailure = (error) => {
  return {
    type: CREATE_RETURNS_FAILURE,
    payload: error,
  };
};

const createReturns = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createReturnsRequest());
    let url = `${baseUrl}/dpp/return_repair_info/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createReturnsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createReturnsFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const editReturnsRequest = () => {
  return {
    type: EDIT_RETURNS_REQUEST,
  };
};

const editReturnsSuccess = (payload) => {
  return {
    type: EDIT_RETURNS_SUCCESS,
    payload: payload,
  };
};

const editReturnsFailure = (error) => {
  return {
    type: EDIT_RETURNS_FAILURE,
    payload: error,
  };
};

const editReturns = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(editReturnsRequest());
    let url = `${baseUrl}/dpp/return_repair_info/update`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(editReturnsSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editReturnsFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const uploadForReturnsValueRequest = () => {
  return {
    type: UPLOAD_RETURNS_REQUEST,
  };
};

const uploadForReturnsValueSuccess = (payload) => {
  return {
    type: UPLOAD_RETURNS_SUCCESS,
    payload: payload,
  };
};

const uploadForReturnsValueFailure = (error) => {
  return {
    type: UPLOAD_RETURNS_FAILURE,
    payload: error,
  };
};

const uploadForReturnsValue = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadForReturnsValueRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_return/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadForReturnsValueSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadForReturnsValueFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  getReturns,
  deleteReturn,
  createReturns,
  editReturns,
  uploadForReturnsValue,
  getRepairCenter,
  //  getDocumentTypeWithPagination
  //  , createDocumentType
};
